"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.featureHelper = exports.checkDealerType = void 0;
var checkDealerType = exports.checkDealerType = function checkDealerType() {
  var dealerTypeData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var dealerType = arguments.length > 1 ? arguments[1] : undefined;
  if (dealerTypeData.length === 0) {
    return true;
  }
  return dealerTypeData.some(function (item) {
    return item.toString() === dealerType;
  });
};
var featureHelper = exports.featureHelper = function featureHelper(featureData, categoryId, dealerType) {
  var isFeatureAvailable = featureData.exceptions.some(function (item) {
    return item.category && item.category.toString() === (categoryId === null || categoryId === void 0 ? void 0 : categoryId.toString()) && checkDealerType(item.dealerType, dealerType);
  });
  return isFeatureAvailable ? !featureData.default : featureData.default;
};